export default "__VITE_ASSET__DprY$_1y__"